"use client";

import { Link } from 'react-router-dom';
const GalleryImg1 = "https://loremflickr.com/378/407/concert,crowd?lock=109";
const GalleryImg2 = "https://loremflickr.com/378/407/festival,event?lock=110";
const GalleryImg3 = "https://loremflickr.com/378/407/conference,people?lock=111";
const GalleryImg4 = "https://loremflickr.com/378/407/party,celebration?lock=112";
const GalleryImg5 = "https://loremflickr.com/378/407/stage,music?lock=113";
const GalleryImg6 = "https://loremflickr.com/378/407/wedding,event?lock=114";
const GalleryImg7 = "https://loremflickr.com/378/407/audience,event?lock=115";
const GalleryImg9 = "https://loremflickr.com/378/407/celebration,crowd?lock=116";

const galleryItems = [
  {
    src: GalleryImg1,
    alt: "Gallery 1",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
  {
    src: GalleryImg2,
    alt: "Gallery 2",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
  {
    src: GalleryImg3,
    alt: "Gallery 3",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
  {
    src: GalleryImg4,
    alt: "Gallery 4",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
  {
    src: GalleryImg5,
    alt: "Gallery 5",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
  {
    src: GalleryImg6,
    alt: "Gallery 6",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
  {
    src: GalleryImg7,
    alt: "Gallery 7",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
  {
    src: GalleryImg9,
    alt: "Gallery 9",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
];

export default function GalleryOne() {
  

  return (
    <section className="gallery-one">
      <div className="container">
        <div className="section-title text-center">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">Latest Gallery</span>
          </div>
          <h2 className="section-title__title">
            An evening for creator & art <br /> lover meet together
          </h2>
        </div>
        <div className="row masonary-layout">
          {galleryItems.map((item, index) => (
            <div
              key={index}
              className={`col-xl-${index === 8 ? 3 : 3} col-lg-6 col-md-6`}
            >
              <div className="gallery-one__single">
                <div className="gallery-one__img">
                  <img src={item.src} alt={item.alt} />
                  <div className="gallery-one__content">
                    <div className="gallery-one__sub-title-box">
                      <div className="gallery-one__sub-title-shape"></div>
                      <p className="gallery-one__sub-title">{item.subtitle}</p>
                    </div>
                    <h4 className="gallery-one__title">
                      <Link to={item.href}>{item.title}</Link>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
